import { Serializer, UISerializableSettlePnlRecord } from '@drift/common';
import { getSettledBalancesHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const useSettledBalancesHistory =
	(): HistoryTableUIProps<UISerializableSettlePnlRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'settled-balances',
			Serializer.Deserialize.UISettlePnl
		);

		return {
			executePageChange,
			filterFn: getSettledBalancesHistoryFilter,
			historyData,
		};
	};
